//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            details: '',
            error: '',
            show: false,
            showDetails: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('show-error', function (error) {
            if (error && error.response) {
                _this.details = '<p>Exception: ' + error.response.data.exception + '</p><p>File: ' + error.response.data.file + '</p><p>Line: ' + error.response.data.line + '</p>';
                _this.show = true;
            }
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/Error.vue
// module id = vsPY
// module chunks = 0 1